import React, { createContext, useContext, useState, useEffect } from 'react';

const OnboardingContext = createContext();

export const useOnboarding = () => {
  const context = useContext(OnboardingContext);
  if (!context) {
    throw new Error('useOnboarding must be used within an OnboardingProvider');
  }
  return context;
};

export const OnboardingProvider = ({ children }) => {
  const [currentTour, setCurrentTour] = useState(null);
  const [currentStep, setCurrentStep] = useState(0);
  const [completedTours, setCompletedTours] = useState(() => {
    const saved = localStorage.getItem('thm_completed_tours');
    return saved ? JSON.parse(saved) : [];
  });
  const [showHelpCenter, setShowHelpCenter] = useState(false);

  useEffect(() => {
    localStorage.setItem('thm_completed_tours', JSON.stringify(completedTours));
  }, [completedTours]);

  const startTour = (tourId) => {
    setCurrentTour(tourId);
    setCurrentStep(0);
  };

  const nextStep = () => {
    setCurrentStep(prev => prev + 1);
  };

  const prevStep = () => {
    setCurrentStep(prev => Math.max(0, prev - 1));
  };

  const endTour = (markComplete = true) => {
    if (markComplete && currentTour && !completedTours.includes(currentTour)) {
      setCompletedTours(prev => [...prev, currentTour]);
    }
    setCurrentTour(null);
    setCurrentStep(0);
  };

  const resetTours = () => {
    setCompletedTours([]);
    localStorage.removeItem('thm_completed_tours');
  };

  const isTourCompleted = (tourId) => completedTours.includes(tourId);

  return (
    <OnboardingContext.Provider value={{
      currentTour,
      currentStep,
      completedTours,
      showHelpCenter,
      setShowHelpCenter,
      startTour,
      nextStep,
      prevStep,
      endTour,
      resetTours,
      isTourCompleted
    }}>
      {children}
    </OnboardingContext.Provider>
  );
};
